import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class PrivacyService {

  constructor(private http: HttpClient, private serviceCallUtilsService: ServiceCallUtilsService) { }
  /**
   * Description: Método que llama el servicio web que obtiene las preguntas frecuentes
   * Autor: Jhoan Vasquez
   * @param paramPolicy indica la el grupo de politicas a consultar
   * @return Listado de grupo de politicas
   */
  getGroupParameters(paramPolicy) {
    return this.serviceCallUtilsService.callSecuredGetWebService(constants.ENDPOINT_GROUP_POLICIES + paramPolicy);
  }
  getAllPolicy() {
    return this.serviceCallUtilsService.callSecuredGetWebService(constants.ENDPOINT_POLICIES);
  }
  getExerciseRight() {
    return this.serviceCallUtilsService.callSecuredGetWebService(constants.ENDPOINT_EXERCISERIGHT);
  }
}
